// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y9s4w9QG_UidiBtX4ox0 {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.asN5f89P0s1s3wB8Fiv6 {
  font-family: "Chakra Petch";
  font-size: 20px;
  font-weight: 500;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}

.yKSmrU_jVqCizGAhx2pt {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 32px;
}

.AQNWY1TEfOfCJ1J7pXAH {
  background-color: #D62828;
  color: white;
}
.AQNWY1TEfOfCJ1J7pXAH:hover {
  color: white;
  border-color: #FCBF49;
}

.BUkwXfyV4BnCMAMSODIC {
  color: #D62828;
  font-family: "Chakra Petch";
  font-size: 18px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/screens/ProjectInterestAdministration/EditProjectInterestModal.module.scss"],"names":[],"mappings":"AAAA;EACC,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACD;;AAEA;EACC,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AACD;;AAEA;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AACD;;AAEA;EACC,yBAAA;EACA,YAAA;AACD;AAAC;EACC,YAAA;EACA,qBAAA;AAEF;;AAEA;EACC,cAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;AACD","sourcesContent":[".editCadetOverlay {\r\n\tbackground-color: rgba(0, 0, 0, 0.6);\r\n\tposition: absolute;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.editCadetContainer {\r\n\tfont-family: \"Chakra Petch\";\r\n\tfont-size: 20px;\r\n\tfont-weight: 500;\r\n\tbackground-color: white;\r\n\tborder-radius: 8px;\r\n\tpadding: 20px;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\trow-gap: 16px;\r\n}\r\n\r\n.editCadetFooter {\r\n\twidth: 100%;\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: space-between;\r\n\tcolumn-gap: 32px;\r\n}\r\n\r\n.deleteButton {\r\n\tbackground-color: #D62828;\r\n\tcolor: white;\r\n\t&:hover {\r\n\t\tcolor: white;\r\n\t\tborder-color: #FCBF49;\r\n\t}\r\n}\r\n\r\n.warningText {\r\n\tcolor: #D62828;\r\n\tfont-family: \"Chakra Petch\";\r\n\tfont-size: 18px;\r\n\tfont-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editCadetOverlay": `y9s4w9QG_UidiBtX4ox0`,
	"editCadetContainer": `asN5f89P0s1s3wB8Fiv6`,
	"editCadetFooter": `yKSmrU_jVqCizGAhx2pt`,
	"deleteButton": `AQNWY1TEfOfCJ1J7pXAH`,
	"warningText": `BUkwXfyV4BnCMAMSODIC`
};
export default ___CSS_LOADER_EXPORT___;
